import React, { useEffect, useState } from 'react';
import {
  Grid,
  makeStyles,
  Card,
  CardContent,
  Container,
  CardHeader,
} from '@material-ui/core';

import Axios from 'axios';
import { grey } from '@material-ui/core/colors';



import CreateAgent from './CreateAgentform'
import AgentTable from './AgentTable'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex'
  },
  grey: {
    color: theme.palette.getContrastText(grey[50]),
    backgroundColor: grey[50]
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  paper: {
    textAlign: 'center'
  },
  list: {},
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    marginRight: '0.5vw'
  },
  listItem: {
    padding: 0
  },
  cardcontent: {
    padding: '0 0 0 5%',
    '&:last-child': {
      paddingBottom: 0
    }
  }
}));


const AgentDashboard = () => {
  const classes = useStyles();
  const [agents, setAgents] = useState([]);

  useEffect(() => {



  }, [])
  function TableData() {
    const url = 'http://106.51.86.75:4000/admin/agent/viewAgent'

    Axios.post(url, {}, { headers: { Authorization: `Bearer ${localStorage.getItem('jwtToken')}` } })
      .then(function (response) {
        // console.log(JSON.stringify(response.data.data));
        setAgents(response.data.data)

      })
      .catch(function (error) {
        console.log(error);
      });

  }
  return (
    // <>
    <Container maxWidth={false}>
      <div className={classes.root}>
        <Grid container spacing={3}>

          <Grid item xs={12} sm={4}>
            <div>

              <Card>
                <CardHeader title={'Create Agent'} />
                <CardContent>
                  <CreateAgent TableData={TableData} />
                </CardContent>
              </Card>

            </div>

          </Grid>
          <Grid item xs={12} sm={8}>
            <div>
              <Card>
                <CardHeader title={'Agent Details'} />
                <CardContent>
                  <AgentTable />
                </CardContent>
              </Card>
            </div>

          </Grid>

        </Grid>
      </div>

    </Container>
    // </>
  );
};

export default AgentDashboard;
